import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "presentation",
  class: "bg-lighten hidden w-[1px] self-stretch sm:block"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemSeparator',
  setup(__props) {

// eslint-disable-line

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1))
}
}

})